// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-button .dx-button-text {\r\n    text-transform: none;\r\n    font-size: 16px;\r\n    letter-spacing: 0%;\r\n    line-height: 100%;\n}\n.custom-button .dx-button-content {\r\n    padding: 15px 45px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
